import i18n from 'i18next'

export const getTranslate = (text: any)=>{
    if(typeof text === 'object'){
        return text[i18n.language]
    }
    return text
}